<template>
  <div class="recyclertAddEdit">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="绑定用户" prop="wlUserId">
        <el-select
          :disabled="isQuery"
          v-model="ruleForm.wlUserId"
          filterable
          remote
          reserve-keyword
          placeholder="请输入关键词"
          :remote-method="remoteMethod"
          :loading="loading"
          @change="wlUserIdchange"
        >
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.nickname + '-' + item.phone"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="姓名" prop="name">
        <el-input :readonly="isQuery" v-model="ruleForm.name"></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="phone">
        <el-input :readonly="isQuery" v-model="ruleForm.phone"></el-input>
      </el-form-item>
      <el-form-item label="街道" prop="street">
        <el-select
          :disabled="isQuery"
          v-model="ruleForm.street"
          @change="streetchange"
          multiple
          placeholder="请选择街道"
        >
          <el-option
            :label="item.name"
            :value="item.id"
            v-for="(item, key) in streetList"
            :key="key"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="社区" prop="communityIds">
        <el-select
          :disabled="ruleForm.street.length == 0 || isQuery"
          v-model="ruleForm.communityIds"
          multiple
          filterable
          remote
          reserve-keyword
          placeholder="请输入关键词"
          :remote-method="remoteMethodcommunity"
        >
          <el-option
            v-for="item in communityList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="联系地址" prop="address">
        <el-input :readonly="isQuery" v-model="ruleForm.address"></el-input>
      </el-form-item>
      <el-form-item label="是否通过" prop="status">
        <el-select
          :disabled="isQuery"
          v-model="ruleForm.status"
          placeholder="请选择是否通过"
        >
          <el-option label="通过" value="0"></el-option>
          <el-option label="不通过" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="头像" prop="avatar">
        <el-upload
          action
          ref="staffImgUpload"
          :file-list="fileList"
          :limit="1"
          :on-exceed="surpass"
          list-type="picture-card"
          :http-request="importFile" 
          :on-remove="staffImgRemove"
          :before-upload="beforeAvatarUpload"
          :on-preview="handlePictureCardPreview">
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>
      <el-form-item v-if="!isQuery">
        <el-button type="primary" @click="submitForm('ruleForm')"
          >提交</el-button
        >
        <el-button @click="resetForm('ruleForm')">重置</el-button>
      </el-form-item>
    </el-form>
    
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import { publicMixin } from "@/mixins/publicMixin";
import { httpAction, uploadAction } from "@/api/manage";
import {
  frontUserlist,
  frontUserrolelist,
  frontUsercheckUserBind,
} from "@/api/management";
export default {
  name: "recyclertAddEdit",
  props: ["isWhat", "recycleData", "isQuery"],
  mixins: [publicMixin],
  data() {
    return {
      url: {
        queryArea: '/address/street/list',
        queryResidentialQuarters: '/address/community/list',
        upload: '/api/upload',
      },
      ruleList: [],
      wlStreetId: [],
      name: "",
      options: [],
      value: [],
      loading: false,
      streetList: [],
      communityList: [],
      ruleForm: {
        wlUserId: "",
        name: "",
        phone: "",
        street: [],
        communityIds: [],
        address: "",
        status: "",
        avatar: "",
        id: "",
      },
      rules: {
        wlUserId: [
          { required: true, message: "请绑定用户", trigger: "change" },
        ],
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { min: 2, max: 5, message: "长度在 2 到 5 个字符", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { min: 11, max: 11, message: "手机号不正确", trigger: "blur" },
        ],
        street: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个街道",
            trigger: "change",
          },
        ],
        communityIds: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个社区",
            trigger: "change",
          },
        ],
        address: [
          { required: true, message: "请输入联系地址", trigger: "blur" },
        ],
        status: [
          { required: true, message: "请选择是否通过", trigger: "change" },
        ],
        avatar: [{ required: true, message: "请上传头像", trigger: "blur" }],
      },
      fileList: [],
      dialogImageUrl: '',
      dialogVisible: false,
    };
  },
  watch: {
    recycleData(val) {
      console.log(val);
      if (val) {
        this.ruleForm.street = [];
        this.ruleForm.communityIds = [];
        val.streetList.forEach((item) => {
          this.ruleForm.street.push(item.id);
        });
        this.getaddresscommunitylist("", this.ruleForm.street);
        val.communityList.forEach((item) => {
          this.ruleForm.communityIds.push(item.id);
        });
        this.ruleForm.wlUserId = val.wlUserId;
        this.ruleForm.name = val.name;
        this.ruleForm.phone = val.phone;
        this.ruleForm.address = val.address;
        this.ruleForm.status = String(val.status);
        this.ruleForm.avatar = val.avatar;
        let result = val.avatar
        ? val.avatar.split(",").reduce((pre, item, index) => {
          if (item) {
            pre.push({ uid: index, url: item });
          }
          return pre;
        }, [])
        : [];
        result.forEach((item) => {
          this.fileList.push(item);
        })
        this.ruleForm.id = val.id;
        let obj = [
          {
            id: val.wlUserId,
            nickname: val.wlUserName,
          },
        ];
        this.options = obj;
      }
    },
  },
  computed: {},
  methods: {
    wlUserIdchange(val) {
      console.log(val);
      frontUsercheckUserBind({
        busiUserId: this.ruleForm.id || "",
        cate: "4" + '',
        wlUserId: val,
      }).then((res) => {
        if (res.code == 200) {
          if (res.data) {
            console.log("验证通过");
          } else {
            console.log("验证未通过");
            this.$message.error("此用户不可被绑定");
            this.ruleForm.wlUserId = "";
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getfrontUserrolelist() {
      frontUserrolelist({
        cate: "1",
      }).then((res) => {
        if (res.code == 200) {
          this.ruleList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getaddresscommunitylist(name, wlStreetId) {
      console.log(name, wlStreetId);
      if (wlStreetId != 0) {
        httpAction(this.url.queryResidentialQuarters, {
          name: name,
          wlStreetId: wlStreetId,
        }, 'post').then((res) => {
          if (res.code == 200) {
            this.communityList = res.data;
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },
    remoteMethodcommunity(query) {
      this.name = query;
      this.getaddresscommunitylist(this.name, this.wlStreetId);
    },
    streetchange(val) {
      this.ruleForm.communityIds = [];
      this.wlStreetId = val;
      this.getaddresscommunitylist(this.name, this.wlStreetId);
    },
    getaddressstreetlist() {
      httpAction(this.url.queryArea, {}, 'get').then((res) => {
        if (res.code == 200) {
          this.streetList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    remoteMethod(query) {
      this.loading = true;
      if (query) {
        frontUserlist({ name: query }).then((res) => {
          if (res.code == 200) {
            this.loading = false;
            this.options = res.data;
          } else {
            this.$message.error(res.msg);
          }
        });
      } else {
        this.options = [];
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit("saveSubmit", this.ruleForm);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.fileList = []
    },
    beforeAvatarUpload(file) {
      let types = ['image/jpeg', 'image/jpg', 'image/bmp', 'image/png'];
      const isIMG = types.includes(file.type);
      const isLt10M = file.size / 1024 / 1024 < 10;

      if (!isIMG) {
        this.$message.error('上传图片只能是 JPG、JPEG、bmp、PNG 格式!');
      }
      if (!isLt10M) {
        this.$message.error('上传头像图片大小不能超过 10MB!');
      }
      return  isIMG && isLt10M;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    importFile(file) {
      console.log(file);
      let formData = new FormData()
      formData.append("businessType",101)
      formData.append("file", file.file, file.file.name); // 如果是base64文件，那么直接把base64字符串转成blob对象进行上传即可
      uploadAction(this.url.upload, formData)
        .then((res) => {
          this.$message.success("上传成功");
          this.ruleForm.avatar = res.data[0]
        })
        .catch((err) => {
          this.$message.error("上传失败");
        });
    },
    staffImgRemove () {
      this.ruleForm.avatar = ''
    },
    surpass() {
      this.$message.warning("最多只能上传一张图片!");
    },
  },
  created() {
    this.getaddressstreetlist();
    this.getfrontUserrolelist();
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-input.is-disabled .el-input__inner {
  background-color: #fff;
  color: #666;
}
::v-deep .el-checkbox__input.is-disabled + span.el-checkbox__label {
  color: #000;
  cursor: not-allowed;
}
.recyclertAddEdit {
  padding: 0px 24px 24px 24px;
  ::v-deep .el-select {
    width: 100%;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
}
</style>
